import swal from 'sweetalert'
import {Errors} from "../constants";

export default {

    EXITO: "success",
    WARN: "warning",
    ERROR: "error",

    alert: function (title, text, fnCallback) {
        swal({
            title: title,
            text: text,
            timer: 5000,
            icon: this.WARN
        })
            .then(value => {
                if (fnCallback) {
                    fnCallback();
                }
                swal.close();
            });
    },

    mensajeExito: function (texto, fnCallback) {
        swal({
            title: "ÉXITO",
            text: texto,
            timer: 5000,
            icon: this.EXITO
        })
            .then(value => {
                if (fnCallback && typeof fnCallback === 'function') {
                    fnCallback();
                }
                swal.close();
            });
    },

    mensajeError: function (texto, fnCallback) {
        swal({
            title: "ERROR",
            text: texto ? texto : Errors.SERVER_UNAVAILABLE,
            timer: 5000,
            icon: this.ERROR
        })
            .then(value => {
                if (fnCallback && typeof fnCallback === 'function') {
                    fnCallback();
                }
                swal.close();
            });
    },

    confirmacion: function (titulo, texto, fnOK, fnCancel) {
        swal({
            title: titulo ? titulo : "Confirmación",
            text: texto,
            icon: "warning",
            buttons: {
                cancelar: {text: "Cancelar", value: "cancel"},
                ok: {text: "Acepto", value: "ok"}
            },
            dangerMode: true
        })
            .then(value => {
                var self = this;
                switch (value) {
                    case "ok":
                        swal.close();
                        if (fnOK) {
                            setTimeout(fnOK, 300);
                        }
                        break;
                    case "cancel":
                        setTimeout(function () {
                            if (fnCancel) {
                                fnCancel();
                            }
                        }, 300);
                        break;
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/util/alert.js